import { createBrowserRouter } from "react-router-dom";
import { Suspense, lazy } from "react";
import Root from "./root";
import ErrorPage from "components/error/error.component";
import { _links } from "utils/helper/links";
import Authentication, {
  AuthOTPPages,
  authOTPRoutes,
  authRoutes,
  WorkerSignupPages,
  workerSignupRoutes,
} from "./auth";
import Preloader from "components/toolkit/preloader.component";
import ProtectedRoutes, { protectedRoutes } from "./protected-routes";
import { _countrLinks } from "utils/helper/country_links";
import PrivacyPolicy from "./privacy_policy/privacy_policy";
import TermsConditions from "./privacy_policy/terms_condition";
import RefundPolicy from "./privacy_policy/refund_policy";

const Home = lazy(() => import("./home"));
const AboutPage = lazy(() => import("./about"));

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<Preloader />}>
        <Root />
      </Suspense>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: _links.about,
        element: <AboutPage />,
      },
      {
        path: _links.privacy,
        element: <PrivacyPolicy />,
      },
      {
        path: _links.refund,
        element: <RefundPolicy />,
      },
      {
        path: _links.terms,
        element: <TermsConditions />,
      },
      {
        path: _links.faq,
        element: <Home isAsk={true} />,
      },
      ..._countrLinks.map((e, i) => ({
        path: `/${e.uri}`,
        element: <Home country={`${e.uri}`} />,
      })),
    ],
  },
  {
    element: (
      <Suspense fallback={<Preloader />}>
        <Authentication />
      </Suspense>
    ),
    loader: () => <Preloader />,
    children: authRoutes,
  },
  {
    element: (
      <Suspense fallback={<Preloader />}>
        <WorkerSignupPages />
      </Suspense>
    ),
    children: workerSignupRoutes,
  },
  {
    element: (
      <Suspense fallback={<Preloader />}>
        <ProtectedRoutes />
      </Suspense>
    ),
    children: protectedRoutes,
  },
  {
    element: (
      <Suspense fallback={<Preloader />}>
        <AuthOTPPages />
      </Suspense>
    ),
    loader: () => <Preloader />,
    children: authOTPRoutes,
  },
]);

export default router;
